import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PartnerOfferingForm from './PartnerOfferingForm';

const NewPartnerOffering = ({ isOpen = false, toggle, refresh, partnerId }) => {
    
    const { availableOfferings } = useSelector((state) => ({
        availableOfferings: state.offering.availableOfferings,
    }));

    const modifiedOfferingObject = useMemo(() => {
        return offeringObject(availableOfferings);
    }, [availableOfferings]);

    return (
        <Modal className="text-light" centered style={{minWidth: '35vw'}} isOpen={isOpen} toggle={toggle}>
            <ModalHeader>New Partner Offering</ModalHeader>
            <ModalBody>
                <PartnerOfferingForm
                    isNew={true}
                    refresh={refresh}
                    toggle={toggle}
                    partnerId={partnerId}
                    offeringsList={modifiedOfferingObject}
                />
            </ModalBody>
            <ModalFooter>&nbsp;</ModalFooter>
        </Modal>
    );
};

const offeringObject = (availableOfferings = []) => {
    return availableOfferings.map((x) => {
        return {
            id: x?.id,
            name: x?.name,
            isEnabled: false,
            subOfferings: x?.subOfferings?.map((s) => {
                return {
                    id: s?.id,
                    name: s?.displayName ?? s?.name,
                    isEnabled: false,
                };
            }),
        };
    });
};

export default NewPartnerOffering;
